var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwoBanknoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 22.59a4.693 4.693 0 004.688-4.688 4.693 4.693 0 00-4.688-4.688 4.693 4.693 0 00-4.688 4.688 4.693 4.693 0 004.688 4.687zm0-7.5a2.816 2.816 0 012.813 2.812 2.816 2.816 0 01-2.813 2.812 2.816 2.816 0 01-2.813-2.812 2.816 2.816 0 012.813-2.813z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.063 5.714H4.688a.938.938 0 00-.938.938v2.812H.937a.938.938 0 00-.937.938v15c0 .518.42.937.938.937H27.25c.518 0 .938-.42.938-.937v-2.813h2.875c.517 0 .937-.42.937-.937v-15a.937.937 0 00-.938-.938zm-4.75 7.34a2.826 2.826 0 01-1.714-1.715h1.713v1.714zm-3.656-1.715a4.701 4.701 0 003.655 3.656v5.814a4.702 4.702 0 00-3.655 3.655H5.53a4.702 4.702 0 00-3.656-3.655v-5.814a4.702 4.702 0 003.656-3.656h17.126zm-19.068 0a2.826 2.826 0 01-1.714 1.714V11.34h1.714zM1.875 22.751c.798.282 1.43.916 1.714 1.713H1.875v-1.713zm22.724 1.713a2.826 2.826 0 011.713-1.713v1.713H24.6zm5.526-3.75h-1.938V10.402a.937.937 0 00-.937-.938H5.625V7.59h24.5v13.125z",
    fill: "#ADC6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 18.84a.938.938 0 100-1.876.938.938 0 000 1.875zM6.625 18.84a.938.938 0 100-1.876.938.938 0 000 1.875z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/two-banknote-icon.9bf0c7689fcf9ddc5035f9b5e176321b.svg";
export { SvgTwoBanknoteIcon as ReactComponent };